import { useState, useEffect } from 'react';
import resim from '@/assets/images/login.png';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FcGoogle } from 'react-icons/fc';
import { FaApple } from 'react-icons/fa';
import { IoMdPhonePortrait } from 'react-icons/io';
import { ImUsers } from 'react-icons/im';
import AcountLoginForm from './AcountLoginForm';
import PhoneLoginForm from './PhoneLoginForm';
import useAuth from '@/features/hooks/useAuth';
import useNotificationApi from '@/services/api/useNotificationApi';
import { renderIcon } from '@/utils/iconRenderer';
// import './Login.css';

function Login() {
  const { login, isAuthenticated, firebaseLogin } = useAuth();
  const { SetDeviceToken } = useNotificationApi();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const ApiVersion = searchParams.get('ApiVersion');
  const Platform = searchParams.get('Platform');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [stage, setStage] = useState('account'); // Başlangıç olarak hesap login
  const [requestPending, setRequestPending] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const isIOSDevice = () => {
      const platform = window.navigator.platform;
      const userAgent = window.navigator.userAgent;

      const iOSPlatforms = ['iPhone', 'iPad', 'iPod'];
      if (iOSPlatforms.includes(platform)) {
        return true;
      }
      if (/Macintosh/.test(userAgent) && 'ontouchend' in document) {
        return true;
      }
      return false;
    };

    setIsIOS(isIOSDevice());
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate(`/`);
    }
  }, [isAuthenticated, navigate]);

  const handleGoogleLogin = async () => {
    try {
      await firebaseLogin('google');
      if (token && ApiVersion && Platform) {
        SetDeviceToken(token, ApiVersion, Platform);
      }
    } catch (error) {
      console.error('Google login failed', error);
    }
  };

  const handleAppleLogin = async () => {
    try {
      await firebaseLogin('apple');
    } catch (error) {
      console.error('Apple login failed', error);
    }
  };
  // const handlePhoneLoginSubmit = async (token) => {
  //   try {
  //     await PhoneLogin(token);
  //   } catch (error) {
  //     console.error('Apple login failed', error);
  //   }
  // };

  const handlePhoneLoginClick = () => {
    setStage('phone'); // Telefon login aşamasına geç
  };

  const handleAccountLoginClick = () => {
    setStage('account'); // Hesap login aşamasına geç
  };

  const handleAccountSubmit = async (userName, password) => {
    setRequestPending(true);
    try {
      await login(userName, password);
      if (token && ApiVersion && Platform) {
        SetDeviceToken(token, ApiVersion, Platform);
      }
    } catch (error) {
      console.error('Login error: ', error);
    } finally {
      setRequestPending(false);
    }
  };

  return (
    <div className="grid grid-cols-1 h-screen place-items-center md:grid-cols-2 lg:grid-cols-2 gap-10 bg-white">
      <div className="hidden md:block ">
        <img src={resim} alt="Login" />
      </div>
      <div className="flex flex-col justify-center items-center w-[90%] h-[90%] mx-2  rounded-lg lg:w-[60%] lg:items-start ">
        <div id="card" className="card w-full shadow-1xl">
          <div
            id="card-title"
            className="flex flex-row items-center justify-start justify-align-content-between  text-success-500 bg-color-header-menu gap-2 p-1 border">
            <img
              src="/images/icons/logo.png"
              className="w-15 h-15"
              alt="Logo"
              width={60}
              height={60}
            />
            <p className="ml-2 text-color-text-white text-xl font-semibold">
              {t('Giris')}
            </p>
          </div>

          <div id="card-body" className=" border p-1 ">
            {stage === 'account' && (
              <AcountLoginForm
                onSubmit={handleAccountSubmit}
                requestPending={requestPending}
              />
            )}

            {stage === 'phone' && (
              <PhoneLoginForm requestPending={requestPending} />
            )}

            <div className="flex justify-center gap-9 my-1">
              {/* Google Login */}
              <FcGoogle size={36} onClick={handleGoogleLogin} />
              {/* Apple Login */}
              {isIOS && <FaApple size={36} onClick={handleAppleLogin} />}
              {/* Stage-based icon */}
              {stage === 'account' ? (
                <IoMdPhonePortrait size={36} onClick={handlePhoneLoginClick} />
              ) : (
                <ImUsers size={36} onClick={handleAccountLoginClick} />
              )}
            </div>
          </div>
          <div
            id="card-footer"
            className="flex justify-start items-center mt-2 border-t  border-gray-300 p-2">
            {renderIcon('help-circle-outline', 32, 'mx-1')}
            <Link to="/auth/forget-password" className="text-sm shadow-sm">
              <h2 className="text-color-text-gray"> {t('SifremiUnuttum')}</h2>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
